//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    DASHBOARD_PANEL_UPDATE_POSITION_GADGET,
    DASHBOARD_PANEL_CREATE_GADGET,
    DASHBOARD_PANEL_UPDATE_GADGET,
} from 'Redux/actionTypes';

//Actions
import {
    updateGadgetPositionDashboardPanelResponse,
    createGadgetDashboardPanelResponse,
    updateGadgetDashboardPanelResponse,
} from 'Redux/actions';

function* createGadgetDashboardRequest({ payload }) {

    try {
        const { gadGet } = payload;

        let query = `
            mutation createUserGadget ($name: String!, $dashboardId: String!, $type: GadgetType!, $settings: AWSJSON, $columnPanel: Int!, $columnOrder: Int!, $refreshSeconds: Int!) {
                result: createUserGadget (name: $name, dashboardId: $dashboardId, type: $type, settings: $settings, columnPanel: $columnPanel, columnOrder: $columnOrder, refreshSeconds: $refreshSeconds) {
                    id
                    dashboardId
                    name
                    type
                    settings
                    columnPanel
                    columnOrder
                    refreshSeconds
                    
                }
            }
          `;
        const response = yield call(
            clientMutation,
            query,
            gadGet,
            endpoints.GRAPHQL_GENERAL
        );
        let createUserGadget = response.result;
        yield put(createGadgetDashboardPanelResponse({ createUserGadget }));

    } catch (exc) {
        yield put(createGadgetDashboardPanelResponse({ data: exc, error: true }));
        ExceptionManager(
            exc,
            "Modules/dashboard/views/.components/dashboardPanel/redux/saga",
            "createGadgetDashboardRequest",
            true
        );
    }
}

function* updateGadgetDashboardRequest({ payload }) {
    try {
        const { gadGet } = payload;

        let query = `
            mutation updateUserGadget ($id: String!, $name: String!, $dashboardId: String!, $type: GadgetType!, $settings: AWSJSON, $columnPanel: Int!, $columnOrder: Int!, $refreshSeconds: Int!) {
                result: updateUserGadget (id: $id, name: $name, dashboardId: $dashboardId, type: $type, settings: $settings, columnPanel: $columnPanel, columnOrder: $columnOrder, refreshSeconds: $refreshSeconds) {
                    id
                    dashboardId
                    name
                    type
                    settings
                    columnPanel
                    columnOrder
                    refreshSeconds
                }
            }
        `;

        let data = {
            id: gadGet.id,
            dashboardId: gadGet.dashboardId,
            name: gadGet.name,
            type: gadGet.type,
            settings: gadGet.settings,
            columnPanel: gadGet.columnPanel,
            columnOrder: gadGet.columnOrder,
            refreshSeconds: gadGet.refreshSeconds
        }

        const response = yield call(
            clientMutation,
            query,
            data,
            endpoints.GRAPHQL_GENERAL
        );

        yield put(updateGadgetDashboardPanelResponse({ data: response.result, error: false }));
    } catch (exc) {
        yield put(updateErrorUserGadgetResponse({ data: exc, error: true }));
        ExceptionManager(
            exc,
            "Modules/dashboard/views/.components/dashboardPanel/redux/saga",
            "updateGadgetDashboardRequest"
        );
    }
}

function* updatePositionGadgetDashboardRequest({ payload }) {
    try {
        const { gadGets } = payload;
        let query = `
            mutation updatePositionUserGadget ($gadGets: [GadgetPosition]) {
              result: updatePositionUserGadget (gadGets: $gadGets)
            }
        `;

        const data = yield call(
            clientMutation,
            query,
            gadGets,
            endpoints.GRAPHQL_GENERAL
        );

        if (data?.result) {
            yield put(updateGadgetPositionDashboardPanelResponse({ data: data?.result }));
        }

    } catch (exc) {
        yield put(updateGadgetPositionDashboardPanelResponse({ error: true }));
        ExceptionManager(
            exc,
            "Modules/dashboard/views/.components/dashboardPanel/redux/saga",
            "updatePositionGadgetDashboardRequest"
        );
    }
}

function* watchDashboardPanelRequests() {
    yield takeEvery(DASHBOARD_PANEL_CREATE_GADGET, createGadgetDashboardRequest);
    yield takeEvery(DASHBOARD_PANEL_UPDATE_GADGET, updateGadgetDashboardRequest);
    yield takeEvery(DASHBOARD_PANEL_UPDATE_POSITION_GADGET, updatePositionGadgetDashboardRequest);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchDashboardPanelRequests)
    ]);
}